import * as React from "react";
import "tw-elements-react/dist/css/tw-elements-react.min.css";
import ReactDOM from "react-dom/client";
import "./index.css";
import "dayjs/locale/it"; // importa il locale italiano

import { RouterProvider, createRouter } from "@tanstack/react-router";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import "./i18n/config";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { toast, ToastBar, Toaster } from "react-hot-toast";
import CloseIcon from "./assets/icons/close_icon.svg";
import ShLinearLoadingIndicator from "./components/ShLinearProgressBar";
import "remixicon/fonts/remixicon.css";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ModalProvider } from "./hooks/UseModalContext";
import ShModal from "./components/ShModal";
import NiceModal from "@ebay/nice-modal-react";
import { ThemeProvider } from "./providers/ThemeProvider";

const queryClient = new QueryClient();

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <>
      <QueryClientProvider client={queryClient}>
        <NiceModal.Provider>
          {/* <ReactQueryDevtools initialIsOpen={true} /> */}

          <React.Suspense fallback={<div>Loading...</div>}>
            <Toaster
              reverseOrder={false}
              position="top-right"
              toastOptions={{
                style: {
                  borderRadius: "4px",
                  marginTop: "20px",
                  padding: "0",
                  background: "#333",
                  fontFamily: "Inter",
                  marginRight: "20px",
                  fontSize: "15px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  letterSpacing: "0.75px",
                  color: "#293641",
                  boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.25)",
                },
                success: {
                  style: {
                    background: "#f4fbf7",
                  },
                  iconTheme: {
                    primary: "#27AE60",
                    secondary: "white",
                  },
                },
                error: {
                  style: {
                    background: "#fbf4f7",
                  },
                  iconTheme: {
                    primary: "#B21F5D",
                    secondary: "white",
                  },
                },
              }}
            >
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <div className="box-border flex relative flex-col">
                      <div className="flex  mr-[10px] justify-between items-center box-border p-2 mb-4 font-sans leading-[20px]">
                        <>
                          {icon}
                          {message}
                        </>
                        <img
                          onClick={() => toast.dismiss(t.id)}
                          src={CloseIcon}
                          alt={""}
                          className="ml-[10px] w-4"
                        />
                      </div>
                      <div className="box-border absolute bottom-0 px-2 pb-2 w-full">
                        {t.type !== "loading" && (
                          <ShLinearLoadingIndicator
                            isCorrect={t.type === "success"}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </ToastBar>
              )}
            </Toaster>
            <ThemeProvider>
              <ModalProvider>
                <ShModal />
                <RouterProvider router={router} />
              </ModalProvider>
            </ThemeProvider>
          </React.Suspense>
        </NiceModal.Provider>
      </QueryClientProvider>
    </>
  );
}
